import commonApi from './CommonApi.js';
var qs = require('querystring');

export default {
	getEnquiryPoint: async (parameter) => {
		return await commonApi().get('/v1/contacts/getEnquiryPoint', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getEnquiryPointCountries: async (parameter) => {
		return await commonApi().get('/v1/contacts/getEnquiryPointCountries', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getEnquiryPointCountriesPaged: async (parameter) => {
		return await commonApi().get('/v1/contacts/getEnquiryPointCountriesPaged', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getNEPForDropdown: async (parameter) => {
		return await commonApi().get('/v1/admin/contacts/getNEPForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getCountryEnquiryPoint: async (parameter) => {
		return await commonApi().get('/v1/contacts/getCountryEnquiryPoint', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getCountryEnquiryPointList: async (parameter) => {
		return await commonApi().get('/v1/contacts/getCountryEnquiryPointList', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getArticle152EnquiryPoint: async (parameter) => {
		return await commonApi().get('/v1/contacts/getArticle152EnquiryPoint', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},	
	getAll: async (parameter) => {
		return await commonApi().get('/v1/admin/contacts/getAll', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/admin/contacts/getById', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	create: async (viewModel) => {
		return await commonApi().post('/v1/admin/contacts', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/admin/contacts', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/admin/contacts', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	exportToExcelEnquiryPoint: async (parameters) => {
		return await commonApi().get('/v1/contacts/exportToExcelEnquiryPoint', {
			params: parameters,
			responseType: 'blob',
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				let fileName;
				if (parameters.domainId == 'SPS') {
					fileName = window.labels.spsNNAsNEPs + '.xlsx';
				}else{
					fileName = window.labels.tbtNNAsNEPs + '.xlsx';					
				}
				let fileURL = window.URL.createObjectURL(new Blob([response.data]));
				let fileLink = document.createElement('a');
				
				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
}